module.exports = __webpack_public_path__ + "img/promolider_logo.f3b4e1ad.png";